export const ModalSteps = {
  SEARCH: 0,
  DETAILS: 1,
  PIN: 2,
  INSTRUCTIONS: 3,
};
